import React from 'react';
import PropTypes from 'prop-types';
import Title from '../base/Title/Title';
import ComplaintTypeSelect from '../ComplaintTypeSelect/ComplaintTypeSelect';
import ComplaintPositionsTable from './ComplaintPositionsTable';
import Button from '../base/Button/GlyphedButton';
import NextBackButton from '../Buttons/NextBackButton';
import {PlusGlyph} from '../glyphicons/Glyphicons';

const ComplaintPositionsList = (props) => {
    return(
        <div className="col-xs-12">
            <Title
                large
                title="Pozycje zgłoszenia" />
            <ComplaintTypeSelect
                complaintType={props.complaintType}
                complaintTypes={props.complaintTypes}
                disabled={props.shouldSelectForComplaintTypeBeDisabled}
                onComplaintTypeChanged={props.onComplaintTypeChanged} />
            <Button
                glyphComponent={<PlusGlyph className="btn-glyphicon"/>}
                label="Dodaj"
                name="btnAddPosition"
                onClick={props.onCreateComplaintPositionButtonClick} />
             <ComplaintPositionsTable
                complaintPositions={props.complaintPositions}
                onDeletePositionBtnClick={props.onDeletePositionBtnClick}
                onEditPositionBtnClick={props.onEditPositionBtnClick} />
            <NextBackButton
                onBackButtonClick={props.onBackButtonClick}
                onNextButtonClick={props.onNextButtonClick} />
        </div>
    );
};

ComplaintPositionsList.propTypes = {
    complaintType: PropTypes.object,
    complaintTypes: PropTypes.array,
    onComplaintTypeChanged: PropTypes.func,
    onCreateComplaintPositionButtonClick: PropTypes.func,
    complaintPositions: PropTypes.array,
    onDeletePositionBtnClick: PropTypes.func,
    onEditPositionBtnClick: PropTypes.func,
    onBackButtonClick: PropTypes.func,
    onNextButtonClick: PropTypes.func,
    shouldSelectForComplaintTypeBeDisabled: PropTypes.bool
};

export default ComplaintPositionsList;


// WEBPACK FOOTER //
// ./src/components/ComplaintPositions/ComplaintPositionsList.js